import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminProductLabel() {
  const { id } = useParams();
  const [label, setLabel] = useState(null);

  useEffect(() => {
    api.get(`/admin/products/${id}/label`).then((r) => setLabel(r.data));
  }, [id]);

  if (!label) return <p className="text-sm text-cream-muted">Loading…</p>;

  return (
    <div data-testid="product-label-page">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3 print:hidden">
        <p className="max-w-xl text-sm font-semibold text-amber-400" data-testid="label-compliance-notice">{label.compliance_notice}</p>
        <button onClick={() => window.print()} className="inline-flex items-center gap-2 rounded-full bg-gold px-5 py-2.5 text-sm font-bold text-choco hover:bg-gold-hover" data-testid="print-label-button">
          <Printer className="h-4 w-4" aria-hidden="true" /> Print
        </button>
      </div>

      <div className="max-w-md rounded-2xl bg-white p-6 text-[#1A0E0A]" data-testid="label-preview">
        <h1 className="font-serif text-xl font-bold">{label.name}</h1>
        <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-[#524339]">Bakes by CR · Handmade to order</p>

        <h2 className="mt-4 text-sm font-bold">Ingredients</h2>
        <p className="mt-1 text-xs leading-relaxed">{label.ingredients || "Not recorded"}</p>

        <h2 className="mt-4 text-sm font-bold">Allergens</h2>
        <p className="mt-1 text-xs font-bold capitalize leading-relaxed" data-testid="label-allergen-declaration">
          {label.allergen_declaration_status === "none_of_14_as_ingredients"
            ? "No UK 14 regulated allergens are used as ingredients."
            : label.allergens.length
              ? `Contains: ${label.allergens.join(", ")}.`
              : "Not reviewed — do not use this label."}
        </p>
        {label.may_contain?.length > 0 && (
          <p className="mt-1 text-xs font-bold capitalize leading-relaxed" data-testid="label-may-contain">
            May contain: {label.may_contain.join(", ")} due to preparation in a kitchen that handles these allergens.
          </p>
        )}
        <p className="mt-1 text-[11px] leading-relaxed text-[#524339]">{label.kitchen_statement}</p>

        {label.dietary_labels.length > 0 && (
          <p className="mt-3 text-xs capitalize"><strong>Dietary:</strong> {label.dietary_labels.join(", ")}</p>
        )}
        <div className="mt-3 space-y-1 text-xs">
          {label.storage_instructions && <p><strong>Storage:</strong> {label.storage_instructions}</p>}
          {label.shelf_life && <p><strong>Best before:</strong> {label.shelf_life}</p>}
          {label.reheat_instructions && <p><strong>To serve:</strong> {label.reheat_instructions}</p>}
        </div>
        {(!label.allergens_verified || !label.ingredients_verified) && (
          <p className="mt-3 rounded-lg border border-red-400 p-2 text-[11px] font-bold text-red-700" data-testid="label-unverified-warning">
            UNVERIFIED — food information on this label has not been confirmed by the owner. Do not use for packing until verified.
          </p>
        )}
      </div>
    </div>
  );
}
